import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { HeaderMenuItemProps } from "../../../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserName } from "../../../helpers";

const HeaderMenuItem: FunctionComponent<HeaderMenuItemProps> = ({
  to,
  name,
  target,
  className,
  icon,
  img,
  src,
  func,
}) => {
  if (name === "Academy") {
    return (
      <a
        href={to}
        onClick={(e) => e.preventDefault()}
        className={`dropdown-toggle ${className}`}
        target={target}
        no-index
      >
        {icon && <FontAwesomeIcon icon={icon} className="user-icon" />}
        {img && (
          <img
            alt={getUserName()}
            src={src}
            className="gravatar-img"
            style={{ borderRadius: "50%", width: "35px" }}
          />
        )}
        {name}
      </a>
    );
  }

  return to && to.indexOf("://") > -1 ? (
    <a
      href={to}
      onClick={func}
      className={`dropdown-toggle ${className}`}
      target={target}
      no-index
    >
      {icon && <FontAwesomeIcon icon={icon} className="user-icon" />}
      {img && (
        <img
          alt={getUserName()}
          src={src}
          className="gravatar-img"
          style={{ borderRadius: "50%", width: "35px" }}
        />
      )}
      {name}
    </a>
  ) : (
    <>
      {!func ? (
        <Link
          to={to || ""}
          target={target}
          onClick={func}
          className={`dropdown-toggle ${className}`}
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          state={to && to === "/#login" ? { goBack: true } : { goBack: false }}
        >
          {icon && <FontAwesomeIcon icon={icon} className="user-icon" />}
          {img && (
            <img
              alt={getUserName()}
              src={src}
              className="gravatar-img"
              style={{ borderRadius: "50%" }}
            />
          )}
          {name}
        </Link>
      ) : (
        <span
          onClick={func}
          className={`dropdown-toggle ${className}`}
          role="button"
        >
          {icon && <FontAwesomeIcon icon={icon} className="user-icon" />}
          {img && (
            <img
              alt={getUserName()}
              src={src}
              className="gravatar-img"
              style={{ borderRadius: "50%" }}
            />
          )}
          {name}
        </span>
      )}
    </>
  );
};

export default HeaderMenuItem;
